var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"need-map"}})
}
var staticRenderFns = []

export { render, staticRenderFns }